// Contact provenance — derived from a contact's `source` string, used by the
// Contacts section (CompanyDetailPage) to show a compact legend + a leading dot
// per contact so it's clear which came from the competitor upload vs discovered
// online (website/LinkedIn/etc.).
//
// `competitor` MUST match the backend's COMPETITOR_CONTACT_SOURCE
// (enrichment/pipeline/contacts.py) — the exact string enrichment writes.
import { colors } from "../theme";

export const COMPETITOR_CONTACT_SOURCE = "Competitor exhibitor list";

// Two origins only — competitor-provided vs enrichment-discovered ("website").
export const CONTACT_SOURCES = {
  competitor: { label: "Competitor", color: colors.brand.orange },
  website:    { label: "Website",    color: colors.text.muted },
};

// Resolve a contact's `source` to an origin key (or null when there's nothing to
// mark). Anything that isn't the competitor label is treated as discovered online.
export function contactOrigin(source) {
  const s = (source || "").trim();
  if (!s) return null;
  return s === COMPETITOR_CONTACT_SOURCE ? "competitor" : "website";
}

// Clean a stored phone value for display: drop any "Label: " prefix (e.g.
// "Main office:") and collapse duplicate numbers into one comma-separated list.
export function formatPhoneValue(value) {
  if (!value) return value;
  const seen = new Set();
  const numbers = [];
  for (const part of String(value).split(",")) {
    const n = part.replace(/^[^:]*:\s*/, "").trim(); // strip a leading "Label: "
    if (n && !seen.has(n)) { seen.add(n); numbers.push(n); }
  }
  return numbers.join(", ") || value;
}
